import React, { useState, useEffect } from "react";
import { Alert, Badge, Button, Card, Table } from "react-bootstrap";
import axios from "../../../../../config/axios";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import PollQuestionItem from "./PollQuestionItem";
import AddQuestionModal from "./AddQuestionModal";


const PollQuestionsListing = ({ pollId }) => {
  //console.log("PollQuestionsListing => ", pollId)
  const [state, setState] = useState({
    isLoading: true,
    status: "fetching", //fetching, fetched, fetchFailed
    error: "",
    data: {},
  });
  const [showAddQuestionModal, setShowAddQuestionModal] = useState(false);

  const loadData = async () => {
    try {
      const res = await axios.get(
        `poll-questions/${pollId}`
      ); //
      //console.log("Poll Questions => ", res);
      setState({
        isLoading: false,
        status: "fetched", //fetching, fetched, fetchFailed
        error: "",
        data: res.data,
      });
    } catch (error) {
      setState({
        isLoading: false,
        status: "fetchFailed", //fetching, fetched, fetchFailed
        error: error,
        data: {},
      });
    }
  };

  useEffect(() => {
    if (pollId) {
      loadData();
    }
  }, [pollId]);

  return (
    <div className="activity-recent-registrations">
      <div className="card-primary mb-0">
        <Card.Header className="cardHead mb-2">
          <Card.Title className="font-weight-bold">
            Manage Questions(s){" "}
            {state.data.pagination && state.data.pagination.totalItems
              ? "- Total " + state.data.pagination.totalItems + " item(s)"
              : null}
          </Card.Title>

          <div class="card-tools mt-0">
            <Button
              variant="primary"
              size="xs"
              onClick={() => setShowAddQuestionModal(true)}
            >
              Add Question
            </Button>
          </div>
        </Card.Header>
        <Card.Body className="m-0 p-0">
          {state.status === "fetchFailed" && state.error ? (
            <Alert variant="danger" className="m-0">
              <b>Error!</b> Fetching items failed.
            </Alert>
          ) : (
            <>
              {!state.data.items || state.data.items.length <= 0 ? (
                <Alert variant="warning" className="m-0">
                  No items found .
                </Alert>
              ) : (
                <>
                  {state.data.items.map((question, index) => {
                    return <PollQuestionItem question={question} loadData={loadData} />
                  })}
                </>
              )}
            </>
          )}
        </Card.Body>

        {state.isLoading && (
          <div class="overlay">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
        )}
      </div>
      <AddQuestionModal
        show={showAddQuestionModal}
        setShow={setShowAddQuestionModal}
        pollId={pollId}
        loadItem={loadData}
      />



    </div>
  );
};

export default PollQuestionsListing;
